import type { ComponentProps, ReactNode } from 'react'

import { Typography } from '../typography'

import type { HeadlineSize } from './headline'
import { useSize } from './size-context'

type Props = {
  children: ReactNode
  className?: string
  titleId?: string
}

export const HeadlineTitle = ({ children, className, titleId }: Props) => {
  const mainSize = useSize()

  const variant: Record<HeadlineSize, ComponentProps<typeof Typography>['variant']> = {
    large: 'h2',
    default: 'h3',
    xl: 'h1Mobile',
  }

  const fontWeightVariant: Record<
    HeadlineSize,
    ComponentProps<typeof Typography>['fontWeight']
  > = {
    large: 'medium',
    default: 'medium',
    xl: 'heavy',
  }

  return (
    <Typography
      className={className}
      color="textPrimary"
      data-testid="headline-title"
      fontWeight={fontWeightVariant[mainSize]}
      id={titleId}
      variant={variant[mainSize]}
    >
      {children}
    </Typography>
  )
}
